import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dialog,
  DialogContent,
  Typography,
  Box,
  TextField,
  IconButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  MenuItem,
  Checkbox,

} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';

import {
  GeneralInfoFields, DueDateFields, DiscountFields, ApplyOnFields,
} from "./paymentTermsConfig"

import API_BASE_URL from '../../../../Constants';




const AddPaymentTermsModal = ({ open, handleClose }) => {

  const [paymentTerm, setPaymentTerm] = useState(
    {
      name: '',
      daysFromType: 1,
      daysFromDays: 0,
      dueType: 1,
      dueTypeDays: 0,
      discount: 1,
      discountDays: 0,
      discountType: 1,
      discountValue: 0,
      salePurchase: false,
      discountApplicable: false,
      freight: false,
      miscellaneous: false,
      tax: false,

    }
  );
  const [isEditMode, setIsEditMode] = useState(true);
  const [isFullView, setIsFullView] = useState(false);



  const toggleFullView = () => {
    setIsFullView((prev) => !prev);
  };

  const toggleEditMode = () => {
    setIsEditMode(!isEditMode);
  };

  const handleClear = () => {
    setPaymentTerm({
      name: '',
      daysFromtype: 1,
      daysFromDays: 0,
      dueType: 1,
      dueTypeDays: 0,
      discount: 1,
      discountDays: 0,
      discountType: 1,
      discountValue: 0,
      salePurchase: false,
      discountApplicable: false,
      freight: false,
      miscellaneous: false,
      tax: false,

    });
  };

  const handleSubmit = () => {

    fetch(`${API_BASE_URL}/api/setup/paymentterms/createPaymentTerms`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(paymentTerm),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log('Success:', data);
        handleClose();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }






  const renderFields = (fields, formData, editable = false) => {
    return fields.map((field) => {
      if (field.key === 'id') return null;
      return (
        <div key={field.key} className="flex items-center py-0.5">
          <h3
            className="flex min-w-[calc(40%-2rem)] my-auto px-2 text-right font-semibold text-lg text-gray-600"
            style={{
              position: 'relative',
              borderBottom: '4px dotted #ccc',  // Changed to dotted border
              paddingBottom: '10px',            // Adds space between text and border
              marginRight: '16px'               // Adds space between label and input
            }}
          >
            {field.label}
          </h3>
          <div className="w-full">

            {field.type === 'text' && (
              <TextField
                fullWidth
                value={formData[field.key]}
                onChange={(e) => setPaymentTerm({ ...paymentTerm, [field.key]: e.target.value })}
                disabled={!editable}
              />
            )}

            {field.type === 'number' && (
              <TextField
                fullWidth
                type="number"
                InputProps={{ inputProps: { min: 0 } }}
                value={formData[field.key]}
                onChange={(e) => setPaymentTerm({ ...paymentTerm, [field.key]: Number(e.target.value) })}
                disabled={!editable}
              />
            )}

            {field.type === 'select' && (
              <TextField

                select
                fullWidth
                value={formData[field.key]}
                onChange={(e) => setPaymentTerm({ ...paymentTerm, [field.key]: e.target.value })}
                disabled={!editable}
              >
                {field.options.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            )}

            {field.type === 'checkbox' && (
              <Checkbox
                checked={formData[field.key]}
                onChange={(e) => setPaymentTerm({ ...paymentTerm, [field.key]: e.target.checked })}
                disabled={!editable}
              />
            )}


          </div>

        </div>
      );

    });
  }

  return (
    <>

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="xl"
        fullWidth={true}
        fullScreen={isFullView}
        PaperProps={{
          sx: {
            backgroundColor: 'white',
            boxShadow: 'none',
            margin: isFullView ? 2 : 'auto',
            width: isFullView ? 'calc(100% - 32px)' : '80%',
            height: isFullView ? 'calc(100% - 32px)' : '80%',
          },
        }}
      >
        <DialogContent


          dividers
          sx={{
            padding: 0,
            maxHeight: '90vh',
            overflowY: 'auto',
            display: 'flex',
            flexDirection: 'column',
          }}
        >

          {/* Sticky Top Section */}
          <Box
            sx={{
              position: 'sticky',
              top: 0,
              backgroundColor: '#f0f4f8',
              zIndex: 2,
              borderBottom: '1px solid #ccc',
              borderTop: '1px solid #ccc',
            }}
          >
            {/* First Row: Back Button and Maximize Button */}
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              paddingY={1}
              paddingX={2}
              sx={{
                backgroundColor: '#e0e0e0',
                borderBottom: '1px solid #ccc',
              }}
            >
              <IconButton
                onClick={handleClose}
                sx={{
                  backgroundColor: '#ffffff',
                  border: '1px solid #ccc',
                  '&:hover': {
                    backgroundColor: '#f0f0f0',
                  },
                }}
                aria-label="Close Modal"
              >
                <ArrowBackIcon />
              </IconButton>
              <IconButton
                onClick={toggleFullView}
                sx={{
                  backgroundColor: '#ffffff',
                  border: '1px solid #ccc',
                  '&:hover': {
                    backgroundColor: '#f0f0f0',
                  },
                }}
                aria-label="Toggle Fullscreen"
              >
                {isFullView ? <FullscreenExitIcon /> : <FullscreenIcon />}
              </IconButton>
            </Box>

            {/* Second Row: Title */}
            <Box
              paddingX={2}
              paddingY={1}
              sx={{
                backgroundColor: '#fafafa',
                borderBottom: '1px solid #ccc',
              }}
            >
              <Typography
                variant="h3"
                component="div"
                className="font-bold"
                sx={{
                  fontSize: { xs: '1.5rem', sm: '2rem' },
                  color: '#333',
                }}
              >
                {

                  "Add Payment Term"
                }
              </Typography>
            </Box>
            {/* Third Row: Action Buttons */}
            <Box
              display="flex"
              alignItems="center"
              paddingX={2}
              paddingBottom={2}
              paddingTop={2}
            >
              {/* Action Buttons */}
              <Box>
                <Button
                  onClick={handleClear}
                  style={{
                    backgroundColor: '#E53E3E',
                    color: 'white',
                    marginRight: '0.5rem',
                    textTransform: 'none',
                    fontWeight: 'bold',
                    transition: 'background-color 0.3s',
                  }}
                  startIcon={<DeleteIcon />}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#C53030';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#E53E3E';
                  }}
                >
                  Clear
                </Button>


                {isEditMode ? (


                  <Button
                    onClick={toggleEditMode}
                    style={{
                      backgroundColor: '#A0AEC0',
                      color: 'black',
                      textTransform: 'none',
                      fontWeight: 'bold',
                      transition: 'background-color 0.3s',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#718096';
                      e.currentTarget.style.color = 'white';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = '#A0AEC0';
                      e.currentTarget.style.color = 'black';
                    }}
                  >
                    View
                  </Button>

                ) : (
                  <>

                    <Button
                      onClick={toggleEditMode}
                      style={{
                        backgroundColor: '#ECC94B',
                        color: 'white',
                        textTransform: 'none',
                        fontWeight: 'bold',
                        transition: 'background-color 0.3s', marginRight: '0.5rem',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#D69E2E';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '#ECC94B';
                      }}
                    >
                      Edit
                    </Button>
                    <Button
                      type='submit'
                      onClick={handleSubmit}
                      style={{
                        backgroundColor: '#4299E1',
                        color: 'white',

                        textTransform: 'none',
                        fontWeight: 'bold',
                        transition: 'background-color 0.3s',
                      }}
                      startIcon={<AddIcon />}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#2B6CB0';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '#4299E1';
                      }}
                    >
                      Add
                    </Button>
                  </>
                )}
              </Box>
            </Box>
          </Box>

          {/* Scrollable Content */}
          <Box sx={{ padding: 2 }}>

            <div className="space-y-5 p-2 rounded-2xl">
              {/* General Information Section */}
              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="general-info-content"
                  id="general-info-header"
                  sx={{ padding: '0 16px' }}
                >
                  <Typography
                    variant="h5"
                    className="font-bold"
                    sx={{
                      paddingBottom: '4px',
                      width: '100%',
                      borderBottom: '1px solid #ccc',
                    }}
                  >
                    General Information
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: '12px' }}>
                  <Box
                    display="grid"
                    gridTemplateColumns={{
                      xs: '1fr',
                      sm: '1fr',
                      md: '1fr',
                      lg: 'repeat(2, 1fr)',
                    }}
                    gap={0.5}
                    className="p-1"
                  >
                    {renderFields(GeneralInfoFields, paymentTerm, isEditMode)}
                  </Box>
                </AccordionDetails>
              </Accordion>

              {/* Due Date Section */}
              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="due-date-content"
                  id="due-date-header"
                  sx={{ padding: '0 16px' }}
                >
                  <Typography
                    variant="h5"
                    className="font-bold"
                    sx={{
                      paddingBottom: '4px',
                      width: '100%',
                      borderBottom: '1px solid #ccc',
                    }}
                  >
                    Due Date
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: '12px' }}>
                  <Box
                    display="grid"
                    gridTemplateColumns={{
                      xs: '1fr',
                      sm: '1fr',
                      md: '1fr',
                      lg: 'repeat(2, 1fr)',
                    }}
                    gap={0.5}
                    className="p-1"
                  >
                    {renderFields(DueDateFields, paymentTerm, isEditMode)}
                  </Box>
                </AccordionDetails>
              </Accordion>

              {/* Discount Section */}
              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="discount-content"
                  id="discount-header"
                  sx={{ padding: '0 16px' }}
                >
                  <Typography
                    variant="h5"
                    className="font-bold"
                    sx={{
                      paddingBottom: '4px',
                      width: '100%',
                      borderBottom: '1px solid #ccc',
                    }}
                  >
                    Discount
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: '12px' }}>
                  <Box
                    display="grid"
                    gridTemplateColumns={{
                      xs: '1fr',
                      sm: '1fr',
                      md: '1fr',
                      lg: 'repeat(2, 1fr)',
                    }}
                    gap={0.5}
                    className="p-1"
                  >
                    {renderFields(DiscountFields, paymentTerm, isEditMode)}
                    {/* <Divider /><Divider /> */}

                    <Typography
                      variant="h5"
                      className="font-bold"
                      sx={{
                        paddingTop: '4px',
                        paddingBottom: '4px',
                        width: '100%',
                        borderBottom: '1px solid #ccc',
                      }}
                    >
                      Applied To
                    </Typography>
                    <Typography
                      variant="h5"
                      className="font-bold"
                      sx={{
                        paddingTop: '4px',
                        paddingBottom: '4px',
                        width: '100%',
                        borderBottom: '1px solid #ccc',
                      }}
                    >

                    </Typography>
                    {renderFields(ApplyOnFields, paymentTerm, isEditMode)}
                  </Box>
                </AccordionDetails>
              </Accordion>

            </div>

          </Box>

        </DialogContent>
      </Dialog>
    </>
  );
};

AddPaymentTermsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};


export default AddPaymentTermsModal;
